/* eslint-disable no-nested-ternary */
import React, { FC } from 'react';
import { Table } from 'components/layout';
import { ColumnsType } from 'antd/lib/table';
import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Menu, Space } from 'antd';
import { IQrUsers } from 'models';

import './qrcodes-table.scss';

const { Item } = Menu;

interface Props {
    data?: IQrUsers[] | null;
    loading: boolean;
    pageSize?: number;
    page: number;
    onChangePage: Function;
    total?: number;
    downloadQrFile: (link: string) => void;
}

const QrCodesTable: FC<Props> = (props: Props) => {
    const { data, pageSize, page, onChangePage, total, loading, downloadQrFile } = props;
    const columns: ColumnsType<IQrUsers> = [
        {
            title: 'Идентификатор пользователя',
            className: 'event-table-name',
            dataIndex: 'userId',
            width: '20%',
        },
        {
            title: 'ФИ',
            className: 'event-table-name',
            render: (_: any, row: IQrUsers) => ` ${row.firstName} ${row.lastName}`,
            width: '15%',
        },
        {
            title: 'Email',
            className: 'event-table-name',
            dataIndex: 'email',
            width: '15%',
        },
        {
            title: 'Дата начала',
            className: 'event-table-name',
            dataIndex: 'startDate',
            width: '15%',
        },
        {
            title: 'Дата окончания',
            className: 'event-table-name',
            dataIndex: 'expirationDate',
            width: '15%',
        },
        {
            title: 'Действия',
            dataIndex: 'actions',
            render: (_: string, row: IQrUsers) => (
                <Dropdown
                    className="dropdown"
                    trigger={['click']}
                    overlay={
                        <Menu>
                            <Item onClick={() => downloadQrFile(row.qrCodeRef)}>Скачать</Item>
                        </Menu>
                    }
                >
                    <Space>
                        Действия
                        <DownOutlined />
                    </Space>
                </Dropdown>
            ),
            width: '8%',
        },
    ];
    return (
        <Table
            className="qrCodes-table"
            data={data}
            page={page}
            pageSize={pageSize}
            total={total}
            columns={columns}
            onChangePage={onChangePage}
            loading={loading}
        />
    );
};

export default QrCodesTable;
